import * as React from 'react';
import type { SVGProps } from 'react';
const SvgInfoGreen = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-label="InfoGreen"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.439 13.002c1.202.866.15 2.315-1.332 2.315H4.893c-1.482 0-2.534-1.45-1.331-2.315C5.115 11.882 7.608 11.5 10 11.5c2.39 0 4.884.382 6.439 1.502"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgInfoGreen;
